import firebase from "firebase/compat/app";

/**
 * Persist Institution setup via Admin SDK callable (client cannot write
 * hierarchyNodes or organizations.setupCompletedAt under Firestore rules).
 */
export async function completeInstitutionSetup({
  institutionId,
  institutionName,
  institutionType,
  regionId,
  subInstitutions,
}) {
  const callable = firebase
    .app()
    .functions("us-central1")
    .httpsCallable("completeInstitutionSetup");
  const result = await callable({
    institutionId,
    institutionName,
    institutionType,
    regionId,
    subInstitutions,
  });
  return result?.data || null;
}
